<template>
    <div>
        <app-sub-title text="Filtros" />
        <div class="d-flex align-items-center">
            <div class="px-2">
                <app-form-text-input 
                    v-model="filters.name"
                    placeholder="Titulo"
                />
            </div>
            <div class="px-2">
                <app-form-text-input 
                    v-model="filters.assignee"
                    placeholder="Responsable"
                />
            </div>
            <div class="px-2">
                <app-form-text-input 
                    v-model="filters.creator"
                    placeholder="Creador"
                />
            </div>
            <div class="px-2">
                <b-button-group>
                    <b-button :variant="filters.date === -1?'success':'secondary'" @click="setDate('vencidas')" >Vencidas</b-button>
                    <b-button :variant="filters.date === 1?'success':'secondary'" @click="setDate('hoy')" >Hoy</b-button>
                    <b-button :variant="filters.date === 2?'success':'secondary'" @click="setDate('mañana')">Mañana</b-button>
                    <b-button :variant="filters.date === 3?'success':'secondary'" @click="setDate('proxima semana')">Próximos 8 días</b-button>
                </b-button-group>
            </div>
            <div class="px-2">
                <b-form-checkbox 
                    id="has-files"
                    v-model="filters.files"
                    value="1"
                    unchecked-value="0"
                >
                Contiene archivos
                </b-form-checkbox>
            </div>
            <div class="px-2">
                <b-button variant="primary" @click="onFilter"><i class="fa fa-filter"></i></b-button>
            </div>
            <div class="px-2">
                <b-button variant="secondary" @click="clearFilters"><i class="fa fa-times-circle"></i></b-button>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data(){
        return {
            filters: {
                name: '',
                files: '',
                date: '',
                assignee: '',
                creator: '',
            }
        }
    },
    methods: {
        onFilter(){
            this.$emit('filter', this.filters);
        },
        setDate(option){
            if(option === 'hoy'){
                this.filters.date = 1;
            }else if(option === 'mañana'){
                this.filters.date = 2;
            } else if(option === 'proxima semana'){
                this.filters.date = 3;
            } else if(option === 'vencidas'){
                this.filters.date = -1;
            }
            this.onFilter();
        },
        clearFilters(){
            Object.keys(this.filters).map(key => this.filters[key] = '');
            this.$emit('filter', null);
        }
    }
}
</script>
